import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripe_api_key = process.env.REACT_APP_STRIPE_KEY;
const stripePromise = loadStripe(stripe_api_key);
const hostURL = process.env.REACT_APP_MODE === "DEV" ? process.env.REACT_APP_DEV_HOST : process.env.REACT_APP_PROD_HOST;
console.log("hostURL is: ", hostURL)

function PaymentForm({ Stripe_PaymentIntent_ID, amount, paymentData, error, setError, setThreeDSApproved, setLoading, setConfirmBtnClicked }) {


  useEffect(() => {

  }, [Stripe_PaymentIntent_ID, amount, paymentData]);



  const handleSubmit = async (event) => {
    event.preventDefault();

    const stripe = await stripePromise;
    setConfirmBtnClicked(1)

    if (!Stripe_PaymentIntent_ID) {
      return;
    }

    try {
      const retrievePaymentIntent = await fetch(hostURL + '/payment/retrievePaymentIntent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Stripe_PaymentIntent_ID: Stripe_PaymentIntent_ID }),
      });


      const data = await retrievePaymentIntent.json();
      console.log("data 1: ", data);

      if (retrievePaymentIntent.ok) {

        if (data.status === "requires_action") {

          const { error: actionError, paymentIntent } = await stripe.confirmCardPayment(data.client_secret);
          console.log("paymentIntent is: ", paymentIntent)
          console.log("actionError is: ", actionError)

          if (paymentIntent !== undefined) {
            if (paymentIntent.status === "requires_confirmation") {

              try {
                const confirmPaymentIntent = await fetch(hostURL + '/payment/confirm-payment-intent', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({ Stripe_PaymentIntent_ID: Stripe_PaymentIntent_ID }),
                });

                if (confirmPaymentIntent.status === 200) {
                  setLoading(false);
                  // setThreeDSApproved("Success"); 
                  // Deferring the parent update can sometimes clear the "rendering" collision
                  setTimeout(() => {
                    setThreeDSApproved("Success");
                  }, 0);
                } else {
                  setLoading(false);
                  setThreeDSApproved("Failed"); 
                }

              } catch (error) {
                setLoading(false);
                setThreeDSApproved("Failed"); 
              }
            } else if (paymentIntent.status === 'succeeded') {
              setLoading(false);
              setThreeDSApproved("Success"); 

            } else {
              setLoading(false);
              setThreeDSApproved("Failed"); 
            }
          } else {
            if (actionError.code === "payment_intent_authentication_failure") {
              setLoading(false);
              setError(actionError.message)
              setThreeDSApproved("Failed"); 
            } else {
              setLoading(false);
              setError(actionError.message)
              setThreeDSApproved("Failed"); 
              return;
            }
          }



        } else if (data.status === 'succeeded') {
          setLoading(false);
          setThreeDSApproved("Success"); 

        } else if (data.last_payment_error) {
          if (data.last_payment_error.code === "payment_intent_authentication_failure") {
          }
        } else {
          setLoading(false);
          setThreeDSApproved("Failed"); 
        }
      } else {
        setLoading(false);
        setThreeDSApproved("Failed"); 
      }
    } catch (error) {
      setLoading(true)
    }
  };

  return (
    <section className="hero container">
      <h1 className="hero-title-primary">Payment Information</h1>
      <p className="hero-title-sub"></p>

      <section className="subscribe-container">
        <div className="hero-top">
          <h4>Card Information</h4>
          <br></br>
          {/* <h5>Please remain on this page after confirming the payment.</h5>
        <h5>Some cards will require futher action for authentication.</h5> */}
        </div>
        <div className="form-container">

          <form id="form" method="post" onSubmit={handleSubmit}>
            <input className="ccForm ccField" type="" name="ccNum" id="ccNum" value={`XXXX-XXXX-XXXX-${paymentData.last4}`} readOnly />
            <input className="ccForm ccField" type="" name="ccExp" id="ccExp" value={`${paymentData.exp_month}/${paymentData.exp_year}`} readOnly />
            {/* <input className="ccForm" type=""  name="ccCVC" id="ccCVC" value={paymentData.display_brand} readOnly/> */}
            <div>
              <input className="ccForm ccField" type="submit" id="submit" value={`Confirm $${paymentData.amount / 100}`} />
            </div>

          </form>


        </div>

        <div className="conditions">
          <h5>Payment Authorization and Acknowledgment</h5>
          <h6 className="p-conditions">By submitting your payment, you authorize  Niagara Concrete to process a pre-authorization charge on your credit card using 3D Secure verification. This pre-authorization charge will hold the estimated amount for your order. The final amount may change based on the actual pour, and you may be charged additional funds or receive a partial refund depending on the final volume of concrete delivered.</h6>
          <h6 className="p-conditions">By completing this process, you confirm that you are the authorized cardholder and approve this pre-authorization charge. The final settlement will occur after the pour, and you will be notified of any adjustments.</h6>
        </div>
      </section>
    </section>

  );
}

export default PaymentForm;